function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageScissorsLeft = function SvgImageScissorsLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    style: {
      fillOpacity: 1,
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-9.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M13.651 24.484q.312 0 .616.1c1.292.425 1.896 2.117 1.358 3.767-.548 1.65-2.037 2.643-3.329 2.218-.525-.166-.949-.553-1.234-1.107-.387-.762-.429-1.731-.125-2.658.457-1.392 1.593-2.322 2.714-2.32M25.835 0 19.57 12.85l-1.676 3.333c-1.57 3.492-.892 3.725-2.592 5.118-1.08.889-2.656 1.735-3.444 2.349-.972.54-1.782 1.504-2.188 2.745-.419 1.255-.338 2.592.202 3.672.438.86 1.154 1.495 2.006 1.773 1.989.658 4.083-.78 5.01-3.072.591-1.47.232-5.498.612-6.927l3.4-5.763c.51-1.237 3.221-6.777 4.331-10.77C26.494.766 26.237.045 25.835 0",
    style: {
      fillOpacity: 1,
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })));
};
export { SvgImageScissorsLeft as ReactComponent };
export default __webpack_public_path__ + "assets/ImageScissors Left.a2a89f365add12aaed1e33edde975553.svg";